import React from 'react'

import { DynamicWithdrawalsActionList } from '@react/dynamic/DynamicWithdrawalsActionList'
import BorrowerAdminWithdrawLedger from '@react/borrower/BorrowerAdminWithdrawLedger'

export const AdminDynamicWithdrawalsTab = (): React.ReactElement => {
  return (
    <>
      <DynamicWithdrawalsActionList />
      {/* <AdminBorrowerWithdrawalsDynamicList />÷ */}
      <BorrowerAdminWithdrawLedger />
    </>
  )
}
